
import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Fab from '@material-ui/core/Fab';
import FaceIcon from '@material-ui/icons/Face';
import Grid from '@material-ui/core/Grid';

import PetsSharpIcon from '@material-ui/icons/PetsSharp';
import MeetingRoomIcon from '@material-ui/icons/MeetingRoom';
import DoneIcon from '@material-ui/icons/Done';

const TitleBox = styled.div`
    padding:10px;
    padding-bottom:10px;
       h4 {
           margin-top:0;
           color:#e64a19;
           text-decoration:underline;
           text-decoration-style:dashed;
       }
       h5 {
           color:red;
           text-decoration:underline;
       }
       p {
           margin:0;
           padding-bottom:10px;
       }
       h6 {
        margin:0;
        padding-bottom:5px;
       }

       h2 {
           color:#757575;
       }
`;


const SubTitleSection = styled.section`
width:80%;
max-width:100%;
background-color:#fffbf0;
display:block;

@media (max-width:${props => props.theme.breakpoints.md}) {
    width:100%;
}
@media (min-width:${props => props.theme.breakpoints.sm}) { 
    display:inline-block;
}
`;

const SubTitle = ({ isphone }) => (
            <SubTitleSection>
        <TitleBox>
            <h4><MeetingRoomIcon color="primary" fontSize="large" />&nbsp;第一次来喜乐的人们！&nbsp;<MeetingRoomIcon fontSize="large" color="secondary" /></h4>

    <h6>喜乐提供好吃的料理</h6>
    <h6>
    好吃好吃好吃哦
    </h6>
    <br />
    <h4><DoneIcon color="primary" />&nbsp;我们的特点&nbsp;<DoneIcon color="secondary"  /></h4>
    <p><DoneIcon style={{ color: "#00bcd4"}} fontSize="small"/>&nbsp;第一点</p> 
    <p><DoneIcon style={{ color: "#00bcd4"}} fontSize="small" />&nbsp;第二点</p>
    <p><DoneIcon style={{ color: "#00bcd4"}} fontSize="small" />&nbsp;第三点</p>
        </TitleBox>
        </SubTitleSection>
        )

SubTitle.propTypes = {
  isphone : PropTypes.bool.isRequired,
}

export default SubTitle;